/**
 * Utility function to initiate a phone call
 * @param phoneNumber - The phone number to call (default: salon number)
 */
export const callPhone = (phoneNumber: string = '7325816834'): void => {
  window.location.href = `tel:${phoneNumber}`;
};

/**
 * Format phone number for display
 * @param phoneNumber - Raw phone number
 * @returns Formatted phone number (e.g., "(732) 581-6834")
 */
export const formatPhoneNumber = (phoneNumber: string): string => {
  const cleaned = phoneNumber.replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return phoneNumber;
};

/**
 * Format US phone number for tel: link with proper country code
 * Prevents duplicate +1 if already present
 * @param phone - Phone number in any format
 * @returns Properly formatted tel: link (e.g., "tel:+19084141074")
 */
export const formatUSPhone = (phone: string): string => {
  const cleaned = phone.replace(/\D/g, '');

  // If already 11 digits and starts with 1 → keep it
  if (cleaned.length === 11 && cleaned.startsWith('1')) {
    return `tel:+${cleaned}`;
  }

  // Otherwise assume US number and add +1
  return `tel:+1${cleaned}`;
};
